import {
  UPDATE_PARTICIPANT_GROUP_LIST,
  UPDATE_PARTICIPANTS_LIST,
  UPDATE_PARTICIPANTS_PROPS,
} from '../mutationTypes';
import {generateIdsObj} from '@/utils/helpers';

export default {
  [UPDATE_PARTICIPANTS_LIST](state, data) {
    state.participantsList = [
      ...state.participantsList,
      ...data,
    ];
    state.participantsById = generateIdsObj(state.participantsList);
  },
  [UPDATE_PARTICIPANT_GROUP_LIST](state, data) {
    const length = (data || []).length;
    const list = (data || []).map((item, idx) => ({...item, weight: item.weight || length - idx}));

    state.participantGroups = list;
    state.participantGroupsById = generateIdsObj(list);
  },
  [UPDATE_PARTICIPANTS_PROPS](state, data) {
    state.participantsProps = data;
  },
};
